import { jsx } from "react/jsx-runtime";
import DraftsIcon from "@mui/icons-material/Drafts";
import { validateTidalLicense } from "../../base/index.js";
function Drafts(props) {
  return /* @__PURE__ */ jsx(
    DraftsIcon,
    {
      "data-testid": "Drafts",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Drafts",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
Drafts.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "Drafts"
};
validateTidalLicense();
export {
  Drafts
};
//# sourceMappingURL=Drafts.js.map
